import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"
import { sendEvent, CNPJ_API_URL, LEAD_API_URL } from './Config';
import LoadingSpinner from './components/LoadingSpinner';
import Footer from './components/Footer';

function validateEmail(email) {
    return email.includes("@") && email.includes(".");
}

const EmailPDF = function () {
    const navigate = useNavigate();
    const enableNotificationsRef = useRef(null);
    const leadIdRef = useRef(localStorage.getItem("lead_id"));
    const [showModal, setShowModal] = useState(0);
    const hasLoadedFirstTime = useRef(false);
    const emailInputRef = useRef(false);
    const [erroEmail, setErroEmail] = useState("");
    const [nifData, setNIFData] = useState(null);
    const nif = useRef(localStorage.getItem("nif"));
    const [emailFocus, setEmailFocus] = useState(false);

    useEffect(() => {
        if (!nif.current) {
            navigate("/")
            return;
        }

        const nifDataStorage = localStorage.getItem(`${nif.current}-data`);

        console.log(nif.current, nifDataStorage);

        if (!nifDataStorage) {
            loadNIFData();
        } else {
            setNIFData(JSON.parse(nifDataStorage));
            setShowModal(0);
        }

        sendEvent(leadIdRef.current ?? false, "email-pdf");
    }, []);

    async function loadNIFData() {
        try {
            const res = await fetch(`${LEAD_API_URL}/onboarding/es/cif/${nif.current}`);

            if (!res.ok) {
                if (res.status === 429) {
                    throw new Error('Muitas requisições. Tente novamente mais tarde.');
                }

                throw new Error(`Erro HTTP: ${res.status}`);
            }

            const json = await res.json();

            console.log(json);

            if (json?.data) {
                localStorage.setItem(`${nif.current}-data`, JSON.stringify(json?.data));
                setNIFData(json?.data);
            }
        } catch (e) {
            console.error(e.message);
        } finally {
            setShowModal(0);
        }
    }

    async function handleFormSubmit(e) {
        e.preventDefault();

        try {
            if (!validateEmail(emailInputRef.current.value)) {
                setErroEmail("Informe seu e-mail corretamente.");
                return;
            }

            localStorage.setItem("email", emailInputRef.current.value);

            if (process.env.NODE_ENV === 'production') {
                var res = await fetch(`${LEAD_API_URL}/onboarding/${leadIdRef.current}/send-email`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        to: emailInputRef.current.value
                    })
                })
            }

            navigate('/onboarding/email/sent');
        } catch (err) {
            console.log(err.message);
        }

        try {
            await sendEvent(leadIdRef.current ?? false, "email-pdf-click");
        } catch (err) {
            console.log(err.message);
        }
    }

    return <>
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Instituto de Crédito Oficial</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>¡Todo listo! La simulación del ICO para su empresa ya se ha completado.</h1>
                    <p className='mt-6 separator-bottom pb-5 mb-5'>El resultado de tu simulación ya está disponible. Introduce tu correo electrónico a continuación para recibir el PDF.</p>
                    <div className='flex flex-col gap-1 separator-bottom pb-5'>
                        {!nifData && <><div>CIF:</div>
                            <strong>{nif.current}</strong></>}
                        {nifData && <>
                            {nifData.name && <>
                                <div className="pt-1">Razón Social:</div>
                                <strong>{nifData.name}</strong>
                            </>}
                            {nifData?.address && <>
                                <div className="pt-1">Dirección:</div>
                                <div className='flex'>
                                    <strong>{nifData.address}</strong>
                                </div>
                            </>}
                            {nifData?.corporate_purpose && <>
                                <div className="pt-1">Propósito Corporativo:</div>
                                <div className='flex gap-x-2'>
                                    <strong>{nifData.corporate_purpose}</strong>
                                </div>
                            </>}
                        </>}
                        <div className="pt-1">Categoría simulada:</div>
                        <strong>De 500 mil € a 4,5 millones €</strong>
                        <div className="pt-1">Plazo de pago:</div>
                        <strong>Hasta 30 años</strong>
                    </div>
                    <div className={`field ${(erroEmail != "" && erroEmail != "validated") ? "error" : ""} ${(erroEmail == "validated") ? "validated" : ""}`}>
                        <input id="nif" ref={emailInputRef} className="mt-4 login" placeholder='CORREO ELECTRÓNICO' type='text' autoComplete='email'
                            onFocus={(e) => {
                                setEmailFocus(true);
                            }}
                            onBlur={(e) => {
                                if (e.target.value.length == 0) {
                                    setEmailFocus(false);
                                    setErroEmail("Campo obligatorio.")
                                    return;
                                }

                                if (validateEmail(e.target.value)) {
                                    setErroEmail("validated");
                                } else {
                                    setErroEmail("Introduce tu correo electrónico correctamente.");
                                }
                            }} />
                        <label>{emailFocus ? "Correo electrónico" : "Introduce un correo electrónico para recibir"}</label>
                        <img src='/assets/img/warning.svg' className="warning" />
                        <img src='/assets/img/check.svg' className="check" />
                        <span className='error-message'>{erroEmail}</span>
                    </div>
                    <button onClick={handleFormSubmit} className="primary w-full mt-6">
                        Enviar PDF a mi correo electrónico
                    </button>
                </div>
            </form>
        </div>
    </>
}

export default EmailPDF;